<template>
<div id="admin-add">
  <bo-add-user title="Nouvel utilisateur"
               subtitle="Back Office"
               action="add"
               :groups="['user']"
               userCss="col-xs-10 col-sm-8 col-md-4"
               @end-edit-user="goToList($event)"
               :routePrefix="routePrefix"
               storePrefix="bouser"></bo-add-user>
</div>
</template>

<script>
import boAddUser from '@/components/boadduser'

export default {
  name: 'admin-add',
  data () {
    return {
      routePrefix: 'admin'
    }
  },
  components: {
    'bo-add-user': boAddUser
  },
  methods: {
    goToList: function (event) {
      this.$router.push(`/${this.routePrefix}/list`)
    }
  }
}
</script>

<style scoped lang="less">

</style>
